<script >
import { computed } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  stock: {
    type: Object,
    default: null
  },
  resource: {
    type: Object,
    default: () => ({})
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const fundamental = computed(() => props.resource?.data?.value || null);
  const companyName = computed(() => props.stock?.companyName || fundamental.value?.companyName || 'N/D');
  const companyDescription = computed(() => props.stock?.companyDescription || fundamental.value?.companyDescription || 'Todavía no disponemos de una descripción ampliada para esta compañía.');
  const sector = computed(() => props.stock?.sector || fundamental.value?.sector || 'N/D');
  const industry = computed(() => props.stock?.industry || fundamental.value?.industry || 'N/D');
  const websiteUrl = computed(() => fundamental.value?.websiteUrl || '');
  const contextLabels = computed(() => [props.stock?.ticker, props.stock?.country || fundamental.value?.country, props.stock?.indexName || fundamental.value?.exchangeName, props.stock?.currency].filter(Boolean));
  return {
    companyName,
    companyDescription,
    sector,
    industry,
    websiteUrl,
    contextLabels
  };
};
export default __sfc_main;
</script>

<template>
    <div class="charting-workspace-inspector__panel-body charting-company-profile">
        <div class="charting-workspace-inspector__summary-cell charting-company-profile__identity">
            <div class="charting-workspace-inspector__summary-label">Compañía</div>
            <div class="charting-workspace-inspector__summary-value charting-company-profile__name">{{ companyName }}</div>
            <div v-if="contextLabels.length" class="charting-company-profile__context">
                <span v-for="(label, index) in contextLabels" :key="`${label}-${index}`">{{ label }}</span>
            </div>
        </div>

        <div class="charting-workspace-inspector__summary-cell">
            <div class="charting-workspace-inspector__summary-label">Actividad</div>
            <div class="charting-company-profile__classification">
                <div><span>Sector</span><strong>{{ sector }}</strong></div>
                <div><span>Industria</span><strong>{{ industry }}</strong></div>
            </div>
        </div>

        <div class="charting-workspace-inspector__summary-cell charting-company-profile__description">
            <div class="charting-workspace-inspector__summary-label">Sobre la empresa</div>
            <p>{{ companyDescription }}</p>
            <a v-if="websiteUrl" class="charting-workspace-inspector__link charting-company-profile__website" :href="websiteUrl" target="_blank" rel="noopener noreferrer">
                <span>Visitar sitio web</span>
                <i class="pi pi-external-link" aria-hidden="true"></i>
            </a>
        </div>
    </div>
</template>

<style scoped>
.charting-company-profile__name { font-size: 1.05rem; font-weight: 800; }
.charting-company-profile__context { display: flex; flex-wrap: wrap; gap: 0.35rem; margin-top: 0.65rem; }
.charting-company-profile__context span { border: 1px solid var(--charting-b-border-color); border-radius: 999px; background: var(--charting-b-panel-bg); padding: 0.22rem 0.5rem; color: var(--p-text-muted-color); font-size: 0.65rem; font-weight: 750; }
.charting-company-profile__classification { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0.55rem; margin-top: 0.65rem; }
.charting-company-profile__classification div { min-width: 0; border-radius: 0.75rem; background: var(--charting-b-panel-bg); padding: 0.65rem; }
.charting-company-profile__classification span, .charting-company-profile__classification strong { display: block; }
.charting-company-profile__classification span { color: var(--p-text-muted-color); font-size: 0.62rem; font-weight: 750; text-transform: uppercase; }
.charting-company-profile__classification strong { margin-top: 0.22rem; overflow-wrap: anywhere; color: var(--p-text-color); font-size: 0.78rem; }
.charting-company-profile__description p { margin: 0.55rem 0 0; color: var(--p-text-muted-color); font-size: 0.82rem; line-height: 1.6; }
.charting-company-profile__website { justify-content: space-between; width: 100%; gap: 0.65rem; border-top: 1px solid var(--charting-b-border-color); padding-top: 0.7rem; text-decoration: none; }
</style>
